import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "36",
  height: "36",
  viewBox: "0 0 36 36",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "18",
      cy: "18",
      r: "17",
      fill: "#161616",
      stroke: "white",
      "stroke-width": "2"
    }, null, -1),
    _createElementVNode("path", {
      d: "M26.605 23.8142C26.5206 23.9481 26.4036 24.0584 26.265 24.1349C26.1265 24.2114 25.9708 24.2516 25.8125 24.2517H20.1875C19.9388 24.2517 19.7004 24.1529 19.5246 23.9771C19.3488 23.8013 19.25 23.5628 19.25 23.3142V11.4392C19.2496 11.2261 19.3218 11.0192 19.4547 10.8527C19.5877 10.6861 19.7734 10.5698 19.9813 10.523C20.1891 10.4761 20.4068 10.5014 20.5983 10.5948C20.7899 10.6882 20.9439 10.8441 21.035 11.0367L26.66 22.9117C26.7276 23.0546 26.7581 23.2122 26.7485 23.37C26.7389 23.5278 26.6895 23.6806 26.605 23.8142ZM21.125 15.6067V22.3754H24.3312L21.125 15.6067ZM9.87498 24.2504C9.7684 24.2504 9.66359 24.2232 9.57051 24.1713C9.47744 24.1193 9.39918 24.0445 9.34319 23.9538C9.2872 23.8631 9.25533 23.7596 9.25061 23.6531C9.24589 23.5466 9.26848 23.4407 9.31623 23.3454L15.5662 10.8454C15.6293 10.7196 15.733 10.6188 15.8605 10.5592C15.988 10.4996 16.1319 10.4849 16.2688 10.5173C16.4058 10.5497 16.5278 10.6273 16.6151 10.7377C16.7025 10.8481 16.75 10.9847 16.75 11.1254V23.6254C16.75 23.7912 16.6841 23.9502 16.5669 24.0674C16.4497 24.1846 16.2907 24.2504 16.125 24.2504H9.87498Z",
      fill: "white"
    }, null, -1)
  ]))]))
}
export default { render: render }